module.exports = __webpack_public_path__ + "img/deletetask.b3c39c9b.svg";